module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18wBMLd/tc-custom/9781460338599.jpg?1708088782387",
      "alt": "This image is the cover for the book Housekeeper's Awakening, At His Service"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Housekeeper's Awakening, At His Service\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A woman is about to discover that being at her boss’s beck and call has its upsides in this captivating romance from the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Recovering from a terrible car accident, world renowned playboy Luis Martinez is bored, grumpy and frustrated. He’s sick of nurses fussing over him, so he fires the lot and demands his sweet, innocent housekeeper massage him back to health!"), _c('br'), _c('br'), _vm._v("Carly Conner has spent her life trying not to be noticed. But now with her boss looking at her differently, every day the tantalizing tension between them grows. When Luis whisks her away to his villa in the south of France, how long will she be able to deny the temptation he poses—especially when he makes a second shocking proposition?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Kendrick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they’ll make your toes curl! She lives in the beautiful city of Winchester – where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating – and drifting into daydreams while working out new plots.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0